import { useEffect, useState } from "react";
import axios from "axios";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  CircularProgress,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function MondayVkd() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchSummary() {
      try {
        const res = await axios.get(
          "https://bflntf7978.execute-api.us-east-1.amazonaws.com/qa/monday-boards-get?boardId=5631751259"
        );

        const boardSummary = res.data?.summary || res.data?.data?.summary;
        if (!boardSummary) {
          console.error("❌ No summary found in API response:", res.data);
          setError("No board summary found.");
          return;
        }

        setSummary(boardSummary);
      } catch (err) {
        console.error("Error fetching board summary:", err);
        setError("Failed to fetch board data.");
      } finally {
        setLoading(false);
      }
    }

    fetchSummary();
  }, []);

  // 🌀 Loading state
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // ❌ Error or no data
  if (error || !summary) {
    return (
      <Typography color="error" sx={{ mt: 2 }}>
        {error || "No data found."}
      </Typography>
    );
  }

  // ✅ Render summary
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        {summary.name}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        State: {summary.state} • Groups: {summary.totalGroups}
      </Typography>

      {/* Groups as accordions */}
      {summary.groups.map((group) => (
        <Accordion key={group.id} sx={{ mb: 1 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "grey.100",
              "&:hover": { backgroundColor: "grey.200" },
            }}
          >
            <Typography sx={{ fontWeight: 500 }}>{group.title}</Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                backgroundColor: "grey.50",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                (No items loaded yet)
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}

